export default {
	Favorites: 'icon-favorites',
	'General Ledger': 'icon-general-ledger',
	'Cash and Bank': 'icon-cash-bank',
	'Accounts Receivable': 'icon-accounts-receivable',
	'Accounts Payable': 'icon-accounts-payable',
	'Journal Reports': 'icon-journal-reports',
	'Schedule Reports': 'icon-schedule-reports',
	Reports: 'icon-reports',
	Monthly: 'icon-monthly',
	Miscellaneous: 'icon-miscellaneous',
	Maintenance: 'icon-maintenance',
	Accounting: 'icon-accounting',
	Vehicles: 'icon-vehicles',
	'F & I': 'icon-fi',
	Vehicle: 'icon-vehicle',
	Sales: 'icon-sales',
	Tax: 'icon-tax',
	Payroll: 'icon-payroll',
	'Payroll Process': 'icon-payroll-process',
	Employee: 'icon-employee',
	Quarterly: 'icon-quarterly',
	Counter: 'icon-counter',
	Management: 'icon-management',
	Cashier: 'icon-cashier',
	Audit: 'icon-audit',
	Inventory: 'icon-inventory',
	Orders: 'icon-orders',
	Manufacturer: 'icon-manufacturer',
	Parts: 'icon-parts',
	Advisor: 'icon-advisor',
	Service: 'icon-service',
	Acura: 'icon-acura',
	Chrysler: 'icon-chrysler',
	Fiat: 'icon-fiat',
	Ford: 'icon-ford',
	GM: 'icon-gm',
	Honda: 'icon-honda',
	Infiniti: 'icon-infiniti',
	Kia: 'icon-kia',
	Lexus: 'icon-lexus',
	Mazda: 'icon-mazda',
	Nissan: 'icon-nissan',
	Subaru: 'icon-subaru',
	Toyota: 'icon-toyota',
	'OEM DCS': 'icon-oem',
	MyVUE: 'icon-vue'
};
